<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'modals.register-clinical-onboarding-candidates.title' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!loading ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container my-5">
    <p class="text-muted small mb-4">{{ 'modals.register-clinical-onboarding-candidates.hint' | translate }}</p>

    <div formArrayName="candidates">
      @for (row of rows.controls; track row; let i = $index) {
        <div class="candidate-row" [formGroupName]="i">
          <mat-form-field appearance="outline" class="candidate-name">
            <mat-label>{{ 'generic.name' | translate }}</mat-label>
            <input matInput formControlName="name" maxlength="255">
            @if (row.get('name').hasError('required')) {
              <mat-error>{{ 'swal.errors.field-mandatory' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" class="candidate-last-name">
            <mat-label>{{ 'modals.register-clinical-onboarding-candidates.last-name' | translate }}</mat-label>
            <input matInput formControlName="last_name" maxlength="255">
          </mat-form-field>
          <mat-form-field appearance="outline" class="candidate-email">
            <mat-label>{{ 'generic.email' | translate }}</mat-label>
            <input matInput formControlName="email" type="email">
            @if (row.get('email').hasError('required')) {
              <mat-error>{{ 'swal.errors.field-mandatory' | translate }}</mat-error>
            } @else if (row.get('email').hasError('email') || row.get('email').hasError('duplicateEmail')) {
              <mat-error>{{ 'generic.error' | translate }}</mat-error>
            }
          </mat-form-field>
          <button mat-icon-button type="button" class="remove-row-btn" [disabled]="rows.length === 1"
            [matTooltip]="'generic.remove' | translate" (click)="removeRow(i)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      }
    </div>

    <button mat-stroked-button type="button" color="primary" class="mt-2" (click)="addRow()">
      <mat-icon class="mr-2">add</mat-icon>
      {{ 'modals.register-clinical-onboarding-candidates.add-row' | translate }}
    </button>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" [disabled]="loading" (click)="closeDialogue()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="loading">{{ 'generic.send' | translate }}</button>
  </div>
</form>
